const PropTypes = require('prop-types');

// @vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const PureRenderMixin = require('react-addons-pure-render-mixin');

// @actions
const intervenersActions = require('actions/getAccountInterveners');
const accountDetailsCertificatesActions = require('actions/accountDetailsCertificates');

// @commons
const { formatText, getFinalTitle } = require('core/i18n').i18n;
const { getLastNChars } = require('utilities/stringHelper');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { CommercialAdsCCValidated: CommercialAds } = require('components/commons/commercialAds/commercialAds');

// @components
const AccountMoreOptionsButton = require('components/accounts/accountMoreOptionsButton/accountMoreOptionsButton');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { AccountDetails } = require('components/accounts/accountDetails/accountDetails');
const AccountInterveners = require('components/accounts/accountInterveners/accountInterveners');
const AccountBalanceToday = require('components/accounts/accountBalanceToday/accountBalanceToday');
const AccountCertificates = require('components/accounts/accountCertificates/accountCertificates');

// @utilities
const AccessHelper = require('utilities/accessHelper');

// @constants
const { accountConstants } = require('utilities/accessHelperConditions/accounts');
const { VIEWER } = require('constants/contactCenter/pdfViewer');

class AccountDetailsView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.callbackDownloadFile = this.callbackDownloadFile.bind(this);
        this.handleOpenPDFViewer = this.handleOpenPDFViewer.bind(this);
    }

    componentDidMount() {
        const { history, immAccounts, match: { params: { accountId } }, requestAccountInterveners } = this.props;
        AccessHelper.allowAccess(accountConstants.ACCOUNTS_DETAILS, { immAccounts, accountId }, history);
        requestAccountInterveners(accountId);
    }

    componentWillUnmount() {
        this.props.clearAccountDetailDocumentState();
    }

    callbackDownloadFile(file) {
        const { match: { params: { accountId } }, immAccounts } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId])
        this.props.getAccountDetailsDocuments(file.get('fileName'), immAccount.get('ibanComplex'));
    }

    handleOpenPDFViewer(file) {
        const { match: { params: { accountId } }, immAccounts } = this.props;
        const immAccount = immAccounts.getIn(['byId', accountId])
        this.props.getAccountDetailsDocuments(file.get('fileName'), immAccount.get('ibanComplex'), VIEWER);
    }

    render() {
        const {
            match: { params: { accountId } },
            immAccounts,
            immInvestmentCredits,
            accountDetailsCertificates,
        } = this.props;
        const immAccount = immAccounts.get('byId').get(accountId);
        const immInvestmentCredit = immInvestmentCredits.getIn(['byId', accountId]);
        let content;

        if (immAccount) {
            const subtitleLeft = immAccount.get('catalogData').get('subtype');
            const subtitleRight = getLastNChars(immAccount.get('iban'));
            const mappingBreadcrumb = [
                {
                    text: formatText('breadcrumb-accounts'),
                    url: '/myprofile/accounts'
                },
                {
                    text: immAccount.get('alias'),
                    url: `/myprofile/accounts/${accountId}/movements`
                },
                {
                    text: formatText('accounts-accountInformation'),
                    url: ''
                }
            ];
            const immInterveners = immAccount.get('interveners');

            // Interveners Info
            const accountInterveners = (
                <AccountInterveners
                    immInterveners={immInterveners}
                    accountId={accountId}
                // requestAccountInterveners={requestAccountInterveners}
                />
            )
            const openPDFOrDownloadFile = __CONTACT_CENTER__ ? this.handleOpenPDFViewer : this.callbackDownloadFile;

            let accountCertificates;

            if (!immAccount.get('isInactiveAccount')) {
                accountCertificates = (
                    <AccountCertificates
                        documents={accountDetailsCertificates.get('documents')}
                        callbackDownloadFile={openPDFOrDownloadFile}
                        isFetching={accountDetailsCertificates.get('isFetchingDocument')}
                    />
                );
            }

            content = (
                <div>
                    <div className="container-fluid">
                        <div className="row account-details-view--header-identifier">
                            <OKCover size="medium" section="accounts" customClass="col-xs-12">
                                <OKHeaderSubPage
                                    breadcrumbConfig={mappingBreadcrumb}
                                    subtitleLeft={subtitleLeft}
                                    subtitleRight={subtitleRight}
                                    finalTitle={getFinalTitle('accountDetails-viewTitle')}>
                                    <AccountMoreOptionsButton accountId={accountId} />
                                </OKHeaderSubPage>
                            </OKCover>
                        </div>
                    </div>
                    <div className="grid-view__body">
                        <div className="container-fluid">
                            <div className="row grid-view--content-position-negative">

                                {/* Interveners on narrow screens */}
                                <div className="col-xs-12 hidden-md hidden-lg grid-view--fix-cell-separation-bottom">
                                    <OKSectionBox>
                                        {accountInterveners}
                                    </OKSectionBox>
                                </div>

                                <div className="col-xs-12 col-md-8">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <OKSectionBox>
                                                <AccountDetails immAccount={immAccount} />
                                                {accountCertificates}
                                                <AccountBalanceToday immAccount={immAccount} immInvestmentCredit={immInvestmentCredit} />
                                            </OKSectionBox>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-xs-12 col-md-4">
                                    <div className="row">

                                        {/* Interveners on wide screens */}
                                        <div className="hidden-xs hidden-sm col-md-12 grid-view--variable-cell-separation">
                                            <OKSectionBox>
                                                {accountInterveners}
                                            </OKSectionBox>
                                        </div>

                                        <div className="col-xs-12 grid-view--fix-cell-separation">
                                            <CommercialAds path="accounts/:accountId/details" type="banner-a" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            content = <LoadingSection />;
        }

        return content;
    }
}

AccountDetailsView.propTypes = {
    history: PropTypes.object.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immInvestmentCredits: PropTypes.object.isRequired,
    requestAccountInterveners: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    getAccountDetailsDocuments: PropTypes.func,
    accountDetailsCertificates: PropTypes.object,
    clearAccountDetailDocumentState: PropTypes.func
};

module.exports.constructor = AccountDetailsView;
module.exports.AccountDetailsView = connect(
    state => ({
        immAccounts: state.accounts,
        immInvestmentCredits: state.creditsInvestment,
        accountDetailsCertificates: state.accountDetailsCertificates
    }), {
    requestAccountInterveners: intervenersActions.requestAccountInterveners,
    getAccountDetailsDocuments: accountDetailsCertificatesActions.getAccountDetailsDocuments,
    clearAccountDetailDocumentState: accountDetailsCertificatesActions.clearAccountDetailDocumentState
}
)(withRouter(AccountDetailsView));
